import { configureStore } from '@reduxjs/toolkit';
import { definitionSlice } from './definitionSlice';
import { querySlice } from './querySlice';
import { uniquePartSlice } from './uniquePartSlice';
import { definitionParameterSlice } from './definitionParameterSlice';
import { treeSlice } from './treeSlice';
import { compareSlice } from './compareSlice';
import { multiPartSlice } from './multipartSlice';

// 使用configureStore创建Redux存储库
// Use configureStore to create the Redux store
export const store = configureStore({
    reducer: {
        // 在这里添加你的reducers，例如这里我们加入definitionSlice的reducer
        // Add your reducers here
        [definitionSlice.reducerPath]: definitionSlice.reducer,
        [querySlice.reducerPath]: querySlice.reducer,
        [uniquePartSlice.reducerPath]: uniquePartSlice.reducer,
        [definitionParameterSlice.reducerPath]: definitionParameterSlice.reducer,
        [treeSlice.reducerPath]: treeSlice.reducer,
        [compareSlice.reducerPath]: compareSlice.reducer,
        [multiPartSlice.reducerPath]: multiPartSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        // 将definitionSlice的中间件添加到默认中间件中
        // Add the middleware from Slices to the default middleware
        getDefaultMiddleware()
            .concat(definitionSlice.middleware)
            .concat(querySlice.middleware)
            .concat(uniquePartSlice.middleware)
            .concat(definitionParameterSlice.middleware)
            .concat(treeSlice.middleware)
            .concat(compareSlice.middleware)
            .concat(multiPartSlice.middleware),
});
